const uploadStatus = {
  approve: 'PENDING',
  revision: 'IN_REVIEW',
  flagged: 'REJECTED'
};

export { uploadStatus };
